import React from 'react';
import { Image } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { DocumentIcon } from 'src/assets/icons';
import Common, { TouchableOpacity } from 'src/components/Common';
import { trackEvent } from 'src/utils/analytics/GAtracker';
import styles from '../style';

const AttachmentRemoveBtn = () => {
  return (
    <Svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <Path
        d="M0.90625 10C0.523438 10.375 0.507812 11.0625 0.914062 11.4609C1.3125 11.8594 2 11.8438 2.375 11.4688L6 7.84375L9.625 11.4609C10.0156 11.8516 10.6875 11.8594 11.0859 11.4531C11.4844 11.0547 11.4844 10.3828 11.0938 9.99219L7.46875 6.375L11.0938 2.75C11.4844 2.35938 11.4844 1.6875 11.0859 1.28906C10.6875 0.882812 10.0156 0.890625 9.625 1.28125L6 4.89844L2.375 1.27344C2 0.898438 1.3125 0.882812 0.914062 1.28125C0.507812 1.67969 0.523438 2.36719 0.90625 2.75L4.53125 6.375L0.90625 10Z"
        fill="#fff"
      />
    </Svg>
  );
};

const AttachmentPreview = ({ data, onRemove }) => {
  return (
    <Common.View style={styles.attachmentPreviewContainer}>
      <Common.View style={styles.attachmentPreviewInner}>
        {data.preview ? (
          <Image style={styles.attachmentPreviewImage} source={{ uri: data.preview }} />
        ) : (
          <Common.Text>
            <DocumentIcon />
          </Common.Text>
        )}
      </Common.View>
      <Common.Text numberOfLines={1} style={styles.attachmentName}>
        {data.file.name}
      </Common.Text>
      <TouchableOpacity style={styles.attachmentRemoveBtn} onPress={() => onRemove(data)}>
        <Common.Text>
          <AttachmentRemoveBtn />
        </Common.Text>
      </TouchableOpacity>
    </Common.View>
  );
};
export default function AttachmentList({ attachments, onChangeAttachments }) {
  const handleRemove = (attachment) => {
    onChangeAttachments([], attachment);
    trackEvent({
      category: 'Attachment',
      action: `remove`,
    });
  };
  return attachments.length ? (
    <Common.View style={styles.attachmentList}>
      {attachments.map((el) => (
        <AttachmentPreview key={el.id} data={el} onRemove={handleRemove} />
      ))}
    </Common.View>
  ) : null;
}
